import React from "react";
import styled from "styled-components";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

const StackedBars = (props) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    barPercentage: 1,
    // minBarLength: 15,
    plugins: {
      legend: {
        position: "bottom",
      },
    },

    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
    // scales: {
    //   x: {
    //     grid: {
    //       display: false,
    //     },
    //   },
    //   y: {
    //     grid: {
    //       borderDash: [4, 2],
    //       color: "#D7DBDE",
    //     },
    //   },
    // },
  };

  return (
    <Tracker centerText={props.centerText}>
      <div className="card">
        <div className="header">
          <div>
            <p className="title">{props.title}</p>
          </div>
        </div>
        <div className="content">
          <Bar options={options} data={props.data} />
        </div>
      </div>
    </Tracker>
  );
};

const Tracker = styled.div`
  .card {
    width: 100%;
    background: #fff;
    position: relative;

    .header {
      font-weight: 600;
      font-size: 18px;
      line-height: 23px;
      padding: 10px 10px 0px;
    }

    .header .title {
      font-size: 1.8rem;
    }

    .content {
      display: grid;
      box-sizing: border-box;
      padding: 2rem;
      row-gap: 1.5rem;
      place-items: center;
      height: 100%;
    }
    select {
      padding: 5px 20px 5px 2px;
      border: 1px solid #f1f1f1;
    }
  }
`;

export default StackedBars;
